import React, { useEffect, useState } from "react";
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { Button } from "@mui/material";

const ExportExcel = ({ requirements }) => {

    const [formattedRequirements, setFormattedRequirements] = useState([]);

    useEffect(() => {
        setFormattedRequirements([])
        formatRequirements(requirements)
    }, [requirements])

    const formatRequirements = (requirements) => {

        requirements.map((req, index) => {
            var text = req.data.aiResponse;

            if (text) {
                 // Function to remove asterisks from markdown headings
                const removeMarkdownFormatting = (text) => {
                    // This regex will match any text surrounded by double asterisks
                    // and replace it with just the text (without the asterisks)
                    return text.replace(/\*\*(.*?)\*\*/g, '$1');
                };
                
                text = removeMarkdownFormatting(text);
                
            }
            const sections = {
                originalRequirement: req.data.question,
                modifiedRequirement: text,
                changesMade: "",
                feedback: "",
                furtherImprovements: ""
            };
            // const modifiedReqMatch = text.match(/Modified Requirement:\s*([\s\S]*?)(?=Changes Made:)/);
            // if (modifiedReqMatch) {
            //     sections.modifiedRequirement = modifiedReqMatch[1].trim();
            // }
            // const changesMadeMatch = text.match(/Changes Made:\s*([\s\S]*?)(?=Feedback:)/);
            // if (changesMadeMatch) {
            //     sections.changesMade = changesMadeMatch[1].trim()
            // }
            // const feedbackMatch = text.match(/Feedback:\s*([\s\S]*?)(?=Further possible improvements:|$)/i);
            // if (feedbackMatch) {
            //     sections.feedback = feedbackMatch[1].trim();
            // }
            // const improvementsMatch = text.match(/Further possible improvements:\s*([\s\S]*)/i);
            // if (improvementsMatch) {
            //     sections.furtherImprovements = improvementsMatch[1].trim()

            // }
            setFormattedRequirements(prev => [...prev, sections])

        })

    }

    const exportToExcel = async () => {

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Requirements');
        const fileName = "RequirementExcel"

        // Adding columns with Styling
        // worksheet.columns = [
        //     { header: 'Orignal Requirement', key: 'original', width: '100' },
        //     { header: 'Modified Requirement', key: 'modified', width: '100' },
        //     { header: 'Changes Made', key: 'changes', width: '100' },
        //     { header: 'Feedback', key: 'feedback', width: '100' },
        //     { header: 'Further Possible Improvements', key: 'further', width: '100' }
        // ]
        worksheet.columns = [
            { header: 'Orignal Requirement', key: 'original', width: '100' },
            { header: 'Modified Requirement', key: 'modified', width: '100' }
        ]
        // Style the header row
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, size: 12 };
        headerRow.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFD3D3D3' } // Light gray background
        };
        formattedRequirements.forEach((req, index) => {
            worksheet.addRow({
                original: req.originalRequirement,
                modified: req.modifiedRequirement,
            })
        })
        // formattedRequirements.forEach((req, index) => {
        //     worksheet.addRow({
        //         original: req.originalRequirement,
        //         modified: req.modifiedRequirement,
        //         changes: req.changesMade,
        //         feedback: req.feedback,
        //         further: req.furtherImprovements
        //     })
        // })
        // Apply text wrapping and borders to all cells
        worksheet.eachRow((row, rowNumber) => {
            row.eachCell((cell) => {
                cell.alignment = {
                    wrapText: true,
                    vertical: 'top',
                    horizontal: 'left'
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });
        try {
            // Generate Excel file
            const buffer = await workbook.xlsx.writeBuffer();

            // Use current date in filename
            const date = new Date().toISOString().slice(0, 10);
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `${fileName}_${date}.xlsx`);
        }
        catch (err) {
            console.error("Error generating Excel file:", err);
            alert("Failed to generate Excel file. Please try again.");
        }

    }

    return (

        <div>
            <Button color='primary' variant="contained" onClick={exportToExcel}>
                Export Excel
            </Button>
        </div>
    )

}
export default ExportExcel;